module.exports = __webpack_public_path__ + "img/project6_1.9d994adc.png";